import React, { Component } from 'react';
import { Nav, NavItem } from 'react-bootstrap';
import NumberUtils from '../../../../utils/NumberUtils';

class ProjectionGridCommitmentEssentialSpends extends Component {
  constructor(props) {
    super(props);

    this.dateConversion = this.dateConversion.bind(this);
    this.getEssentialSpends = this.getEssentialSpends.bind(this);
    this.getCommitments = this.getCommitments.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.getButton = this.getButton.bind(this);
    this.getMessage = this.getMessage.bind(this);

    this.state = {
      contentFlag: true,
      activeCss1: 'active',
      activeCss2: '',
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  dateConversion(value) {
    if (value !== '') {
      const monthName = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      const fullDate = new Date(value);
      const day = fullDate.getDate();
      const month = fullDate.getMonth();
      const year = fullDate.getFullYear();
      const dateStr = `${`0${day}`.slice(-2)} ${monthName[month].substr(
        0,
        3
      )} ${year.toString().substr(2, 4)}`;
      return <label>{dateStr}</label>;
    }
  }
  getEssentialSpends() {
    let tag;
    if (
      this.props.projectionSummary.projection_periods[this.props.index] !==
      undefined
    ) {
      tag = this.props.projectionSummary.projection_periods[
        this.props.index
      ].essential_spend_info.essential_spend.map((eSpendings, index) => (
        <div
          className="spending-trans"
          ref="essential"
          key={`ProjectionGridCommitmentEssentialSpends_getEssentialSpends_${index}`}
        >
          <div className="details">
            <section>
              <span className="icon icon-tag" />
              &nbsp;&nbsp;{eSpendings.display_name}
            </section>
            <section>
              <strong>
                {NumberUtils.appendCurrency('{}', eSpendings.amount.value)}
              </strong>
            </section>
          </div>
        </div>
      ));
      return <div className="spending-list">{tag}</div>;
    }
  }

  getCommitments() {
    let ctrans;
    let message;
    let ctotalAmount;
    if (
      this.props.projectionSummary.projection_periods[this.props.index] !==
      undefined
    ) {
      ctrans = this.props.projectionSummary.projection_periods[
        this.props.index
      ].projected_transactions.transactions.map((tData, index) => (
        <div
          className="commitment-trans"
          ref="commit"
          key={`ProjectionGridCommitmentEssentialSpends_getCommitments_${index}`}
        >
          <h5>{this.dateConversion(tData.when)}</h5>
          <div className="details">
            <section>{tData.display_name}</section>
            <section>
              <strong>
                {NumberUtils.appendCurrency('{}', tData.amount.value)}
              </strong>
            </section>
          </div>
          <p>{tData.type} </p>
        </div>
      ));
      return <div className="commitment-list">{ctrans}</div>;
    } else {
      return <div className="" />;
    }
  }

  handleSelect(selectedKey) {
    if (selectedKey === 1) {
      window.scrollTo(0, 0);
      this.setState({
        contentFlag: true,
        activeCss1: 'active',
        activeCss2: '',
      });
      // this.refs.commit.scrollTop = 0;
    } else {
      this.setState({
        contentFlag: false,
        activeCss1: '',
        activeCss2: 'active',
      });
      // this.refs.spending.scrollTop = 0;
    }
  }

  getButton() {
    return (
      <Nav
        justified
        activeKey={this.state.activeKey}
        onSelect={this.handleSelect}
      >
        <NavItem eventKey={1} href="#account" className={this.state.activeCss1}>
          Commitments
        </NavItem>
        <NavItem
          eventKey={2}
          title="#timeline"
          className={this.state.activeCss2}
        >
          Essential Spend
        </NavItem>
      </Nav>
    );
  }

  getMessage() {
    let message;
    if (this.state.contentFlag) {
      let ctrans;
      if (
        this.props.projectionSummary.projection_periods[this.props.index] !==
        undefined
      ) {
        if (
          this.props.projectionSummary.projection_periods[this.props.index]
            .projected_transactions.transactions.length > 0
        ) {
          if (
            this.props.projectionSummary.projection_periods[this.props.index]
              .projected_transactions.total_amount.value !== 0
          ) {
            if (
              this.props.projectionSummary.projection_periods[this.props.index]
                .projected_transactions.transactions.length === 1
            ) {
              return (message = (
                <span>
                  You have{' '}
                  {
                    this.props.projectionSummary.projection_periods[
                      this.props.index
                    ].projected_transactions.transactions.length
                  }{' '}
                  commitment. This comes to{' '}
                  <strong>
                    {NumberUtils.appendCurrency(
                      '{}',
                      this.props.projectionSummary.projection_periods[
                        this.props.index
                      ].projected_transactions.total_amount.value
                    )}
                  </strong>
                </span>
              ));
            } else {
              return (message = (
                <span>
                  You have{' '}
                  {
                    this.props.projectionSummary.projection_periods[
                      this.props.index
                    ].projected_transactions.transactions.length
                  }{' '}
                  commitments. These come to{' '}
                  <strong>
                    {NumberUtils.appendCurrency(
                      '{}',
                      this.props.projectionSummary.projection_periods[
                        this.props.index
                      ].projected_transactions.total_amount.value
                    )}
                  </strong>
                </span>
              ));
            }
          } else {
            return (message = 'You have no commitments');
          }
        } else {
          return (message = 'You have no commitments');
        }
      } else {
        return (message = 'You have no commitments');
      }
    } else {
      if (
        this.props.projectionSummary.projection_periods[this.props.index] !==
        undefined
      ) {
        if (
          this.props.projectionSummary.projection_periods[this.props.index]
            .essential_spend_info.total_amount.value !== 0
        ) {
          return (message = (
            <span>
              You've tagged{' '}
              <strong>
                {NumberUtils.appendCurrency(
                  '{}',
                  this.props.projectionSummary.projection_periods[
                    this.props.index
                  ].essential_spend_info.total_amount.value
                )}
              </strong>{' '}
              as essential spend
            </span>
          ));
        } else {
          return (message = 'You have no essential spend');
        }
      } else {
        return (message = 'You have no essential spend');
      }
    }
  }

  render() {
    let buttonCss;
    if (this.state.contentFlag) {
      buttonCss = 'button-color';
    } else {
      buttonCss = '';
    }
    return (
      <div className="projection-mobile closer-look">
        <div className="projection-grid-heading">
          <div className="row no-gutters">
            <div className="col-xs-3">
              <button className="page-back white" onClick={this.props.getBack}>
                <span className="icon icon-page-back" />
                Back
              </button>
            </div>
            <div className="col-xs-6 text-center">
              <h5>Projections</h5>
            </div>
            <div className="col-xs-3 text-right">
              <button
                className="icon icon-settings"
                onClick={this.props.goToProjectionSettingsPage}
              />
            </div>
          </div>
        </div>
        <div className="projection-grid">
          <div className="projection-tabs">{this.getButton()}</div>
          <div className="projection-msg">{this.getMessage()}</div>
          <div className="projection-scrollable">
            {this.state.contentFlag
              ? this.getCommitments()
              : this.getEssentialSpends()}
          </div>
        </div>
      </div>
    );
  }
}

export { ProjectionGridCommitmentEssentialSpends };
